/**
 * What full night multiplies the world by: a blue that keeps a little more
 * than half the light, so every creature, path and telegraph still reads.
 */
const NIGHT_COLOR = 0x8c96c8;

/** Full light (white, which a multiply leaves alone) toward `NIGHT_COLOR`, by `darkness` (0 to 1). */
export function shadeColor(darkness: number): number {
  const channel = (shift: number): number => {
    const night = (NIGHT_COLOR >> shift) & 0xff;
    return Math.round(255 + (night - 255) * darkness) << shift;
  };
  return channel(16) | channel(8) | channel(0);
}
